import { combineReducers } from "redux";
import waitingReducer from "./waitingReducer";
import authReduder from "./authReducer";
import recordsReducer from "./recordsReducer";

export default combineReducers({
    wait: waitingReducer,
    auth: authReduder,
    records: recordsReducer,
});